import { AvailabilityData, ConfigurationData, DropdownOption, FieldConfig, NetworkSetupData } from "./types";

export const MAPPING_FIELDS: FieldConfig[] = [
  {
    key: 'product_description',
    label: 'description',
    isMandatory: true,
    allowedSources: ['Field', 'Attribute'],
  },
  {
    key: 'product_min_ad_price',
    label: 'min-ad-price',
    isMandatory: true,
    allowedSources: ['Field', 'Attribute', 'Fixed Value'],
    fixedValue: '100',
  },
  {
    key: 'product_upc',
    label: 'upc',
    isMandatory: false,
    allowedSources: ['Field', 'Attribute'],
  },
];

export const SOURCE_OPTIONS: DropdownOption[] = [
  { label: 'Field', value: 'Field' },
  { label: 'Attribute', value: 'Attribute' },
  { label: 'Fixed Value', value: 'Fixed Value' },
];

export const PRODUCT_FIELD_OPTIONS: DropdownOption[] = [
  { label: 'sku', value: 'sku' },
  { label: 'productId', value: 'productId' },
  { label: 'variantId', value: 'variantId' },
  { label: 'productFamilyId', value: 'productFamilyId' },
  { label: 'familyName', value: 'familyName' },
];

export const GMS_API_OPTIONS: DropdownOption[] = [
  { label: 'V1', value: 'v1' },
  { label: 'V2', value: 'v2' },
  { label: 'V3', value: 'v3' },
  { label: 'V4', value: 'v4' },
];

export const IMPORT_TYPE_OPTIONS: DropdownOption[] = [
  { label: 'SFTP', value: 'SFTP' }
];

export const AVAILABILITY_OPTIONS: DropdownOption[] = [
  { label: 'FULL', value: 'FULL' },
  { label: 'PARTIALLY AVAILABLE', value: 'PARTIAL_AVAILABLE' },
  { label: 'DELTA', value: 'DELTA' },
];

export const INITIAL_NETWORK_SETUP: NetworkSetupData = {
  sftp_host: null,
  sftp_username: null,
  sftp_password: null,
  port: null,
  file_location: null,
  import_type: null,
  is_debugging: false,
  partial_processing: false,
  email_ids: [''],
};

export const INITIAL_PRODUCT_MAPPINGS: Record<string, { source: string; value: string }> = {
  product_description: { source: '', value: '' },
  product_min_ad_price: { source: '', value: '' },
  product_upc: { source: '', value: '' },
};

export const INITIAL_AVAILABILITY: AvailabilityData = {
  availability: 'FULL',
};

export const INITIAL_CONFIGURATION: ConfigurationData = {
  network_setup: INITIAL_NETWORK_SETUP,
  product: INITIAL_PRODUCT_MAPPINGS,
  availability: INITIAL_AVAILABILITY,
  gms_endpoint: null,
  log_location: null,
  feed_configurations: [],
  connector_versions: {},
};